module.exports = __webpack_public_path__ + "img/remote_fire.98de494f.jpg";